import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  standalone: true,
  imports: [],
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss',
})
export class VideoComponent implements OnChanges {
  @Input() embed!: string;
  @Input() _editable!: string;
  _embed: any;
  @Input() _uid!: string;
  @Input() component!: string;

  constructor(private dom: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    this._embed = this.dom.bypassSecurityTrustHtml(this.embed);
  }
}
